<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <app-report-error-list [errors]="data.description"></app-report-error-list>
</mat-dialog-content>

<mat-dialog-actions>
  @if (data.showCancelButton) {
    <button mat-button class="cancel-button" mat-dialog-close>
      {{ 'SHARED.DIALOGS.DIALOG.CANCEL' | translate }}
    </button>
  }
  <button
    mat-raised-button
    [class]="data.sharedButtonClass"
    [ngClass]="{
      'mat-primary': data.sharedButtonClass === 'warningButton',
      'mat-accent': data.sharedButtonClass === 'successButton',
      'mat-warn': data.sharedButtonClass === 'deleteButton',
    }"
    mat-dialog-close="true"
  >
    {{ data.sharedButtonText }}
  </button>
</mat-dialog-actions>
